<div class="time-picker">
    <div class="time-left-split">
        <div class="filter-option" matRipple (click)="timeFilterSelection(item)"
            (keydown.enter)="timeFilterSelection(item)" (keydown.space)="timeFilterSelection(item)" [ngClass]="{'selected':selectedTimeFilter?.code==item?.code,
                'disabled':item?.disabled}" *ngFor="let item of timeFilterList;">
            {{item?.label | translate}}
        </div>
    </div>
    <div class="time-right-split">
        <div class="month-filter"
            *ngIf="selectedTimeFilter?.code=='month' || selectedTimeFilter?.code=='year' || selectedTimeFilter?.code=='quarter'">
            <div class="month-header">
                <div class="yearContainer" *ngIf="ShowMonthFilterheader && selectedTimeFilter?.code!='quarter'">
                    <div class="yearText" *ngIf="!multipleSelection ">
                        {{monthNames[monthFilterMonthSelected]}} {{monthFilterQuaterSelected?.month}}
                        {{monthFilterYearSelected}}
                    </div>
                    <div class="yearText"
                        *ngIf="multipleSelection && selectedTimeFilter?.code!='year' && !selectedPrevious">
                        {{monthFilterSelectedMonth}} <br />
                    </div>
                    <div class="yearText"
                        *ngIf="multipleSelection && selectedTimeFilter?.code!='year' && selectedPrevious">
                        {{monthFilterSelectedMonth}}<br />
                        {{monthFilterYearSelected}}
                    </div>
                    <div class="yearText" *ngIf="multipleSelection && selectedTimeFilter?.code=='year'">
                        {{monthFilterYearSelected}}
                    </div>

                </div>
                <div class="yearContainer" *ngIf="ShowMonthFilterheader && selectedTimeFilter?.code=='quarter'">
                    <div class="yearText" *ngIf="multipleSelection && !selectedPreviousQuarter">
                        {{monthFilterSelectedQuarter}}
                    </div>

                    <div class="yearText" *ngIf="multipleSelection && selectedPreviousQuarter">
                        {{monthFilterSelectedQuarter}} <br />
                        {{monthFilterYearSelected}}
                    </div>
                    <div class="yearText" *ngIf="!multipleSelection">
                        {{monthNames[monthFilterMonthSelected]}} {{ monthFilterQuaterSelected?.month}}
                        {{monthFilterYearSelected}}

                    </div>
                </div>
                <div class="year-controller" *ngIf="ShowMonthFilterheader">
                    <button mat-button class="left-arrow"
                        [class.enabled-color]="!previousYearDisabled && !showMonthFilterYear"
                        (click)="monthFilterPreviousYear()" [disabled]="previousYearDisabled || showMonthFilterYear">
                        <mat-icon aria-hidden="false" aria-label="Previous year">
                            keyboard_arrow_left
                        </mat-icon>
                    </button>
                    <button mat-button class="right-arrow"
                        [class.enabled-color]="!nextYearDisabled && !showMonthFilterYear"
                        (click)="monthFilterYearNextChange()" [disabled]="nextYearDisabled || showMonthFilterYear">
                        <mat-icon aria-hidden="false" aria-label="Next year">
                            keyboard_arrow_right
                        </mat-icon>
                    </button>
                </div>
            </div>
            <div class="months-contents">
                <ng-container *ngIf="showMonthFilterYear && selectedTimeFilter?.code!='quarter'">
                    <div class="year-options" matRipple (click)="monthFilterYear(iYear)"
                        (keydown.enter)="monthFilterYear(iYear)" (keydown.space)="monthFilterYear(iYear)"
                        [ngClass]="{'selected':monthFilterYearSelected==iYear, 'disabled-year': today.getMonth() === 0 && iYear==currentYear}"
                        *ngFor="let iYear of monthFilterYears;">
                        {{iYear}}
                    </div>
                </ng-container>
                <!--Insight code-->
                <ng-container *ngIf="ShowMonthFilterMonth && selectedTimeFilter?.code!='quarter' && !multipleSelection">
                    <div class="month-options" (click)="monthFilterMonth(iMonth)"
                        (keydown.enter)="monthFilterMonth(iMonth)" (keydown.space)="monthFilterMonth(iMonth)" [ngClass]="{'selected':monthFilterMonthSelected===iMonth.code,
                        'disabled-month': monthFilterYearSelected === currentYear && iMonth.code > currentMonth}"
                        *ngFor="let iMonth of monthFilterMonths;">
                        {{iMonth.label}}
                    </div>
                </ng-container>
                <!--Insight code ends-->
                <!--waste dashboard code-->
                <ng-container *ngIf="ShowMonthFilterMonth && selectedTimeFilter?.code!='quarter' && multipleSelection">
                    <ng-container *ngFor="let iMonth of monthList;let index = index">
                        <div class="month-options" (click)="monthFilterMonth(iMonth)"
                            (keydown.enter)="monthFilterMonth(iMonth)" (keydown.space)="monthFilterMonth(iMonth)"
                            [ngClass]="{'selected':iMonth.isSelected,
                    'disabled-month': monthFilterYearSelected === currentYear && iMonth.code > currentMonth+1, 'disabledPrevious': iMonth.monthDisabled}"
                            *ngIf="iMonth.year === monthFilterYearSelected">
                            {{iMonth.label}}
                        </div>
                    </ng-container>
                </ng-container>
                <!--waste dashboard code ends-->
                <ng-container *ngIf=" selectedTimeFilter?.code === 'quarter'">
                    <div class="quarter-container">
                        <div class="quarter-wrapper" *ngIf="multipleSelection">
                            <ng-container *ngFor="let monthObj of quarterList; let index = index">
                                <div class="quarter-tile" (click)="selectQuarter(monthObj)"
                                    (keydown.enter)="selectQuarter(monthObj)" (keydown.space)="selectQuarter(monthObj)"
                                    [class.qtr-select]="monthObj.isSelected"
                                    [class.disable-tile]="getQuarterList() && getQuarterList().length > 0 && 
                                monthFilterYearSelected === getQuarterList()[0] && monthObj.code > getQuarterList()[1] "
                                    [class.disabledPrevious]="monthObj.quarterDisabled"
                                    *ngIf="monthFilterYearSelected === monthObj.year">
                                    <span class="quarter-title" [class.qtr-select-title]="monthObj.isSelected"
                                        [class.disabledPrevious]="monthObj.quarterDisabled">Q{{monthObj.indexValue}}</span>
                                    <span class="quarter-month" [class.qtr-select-month]="monthObj.isSelected"
                                        [class.disabledPrevious]="monthObj.quarterDisabled">{{monthObj.month}}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div class="quarter-wrapper" *ngIf="!multipleSelection">
                            <!--Insight code starts -->
                            <div class="quarter-tile" (click)="selectQuarter(monthObj)"
                                (keydown.enter)="selectQuarter(monthObj)" (keydown.space)="selectQuarter(monthObj)"
                                [class.qtr-select]="monthObj.isSelected"
                                [class.disable-tile]="getQuarterList() && getQuarterList().length > 0 && 
                                    monthFilterYearSelected === getQuarterList()[0] && monthObj.code > getQuarterList()[1]"
                                *ngFor="let monthObj of quarterListNew; let index = index">
                                <span class="quarter-title" [class.qtr-select-title]="monthObj.isSelected">Q{{index +
                                    1}}</span>
                                <span class="quarter-month"
                                    [class.qtr-select-month]="monthObj.isSelected">{{monthObj.month}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="week-filter" *ngIf="selectedTimeFilter?.code=='week'">
            <div class="selectedDate">
                <span class="week-from-date">
                    <div class="from-text">From:</div>
                    <div class="from-date">
                        <span matPrefix class="selectedDateSpan">{{this.selectedWeek | date : "dd MMMM yyyy"}}</span>
                        <mat-icon matSuffix class="selectedDateIcon" (click)="editHourSelectedDate()"
                            (keydown.enter)="editHourSelectedDate()"
                            (keydown.space)="editHourSelectedDate()">calendar_today
                        </mat-icon>
                    </div>
                </span>
                <span class="week-to-date">
                    <div class="to-text">To:</div>
                    <div class="to-date">
                        <span matPrefix class="selectedDateSpan">{{this.daysWeekSelected | date : "dd MMMM
                            yyyy"}}</span>
                        <mat-icon matSuffix class="selectedDateIcon" (click)="editHourSelectedDate()"
                            (keydown.enter)="editHourSelectedDate()"
                            (keydown.space)="editHourSelectedDate()">calendar_today
                        </mat-icon>
                    </div>
                </span>
            </div>
            <mat-calendar [selected]="selectedWeek" [maxDate]="maxWeekDate" [minDate]="minimumCalendarDate"
                (selectedChange)="onWeekSelect($event)"></mat-calendar>
        </div>
        <div class="day-filter" *ngIf="selectedTimeFilter?.code=='day'">
            <mat-calendar [selected]="selectedDate" [maxDate]="today" [minDate]="minimumCalendarDate"
                (selectedChange)="onDateSelect($event)"></mat-calendar>
        </div>
        <div class="shift-filter" *ngIf="selectedTimeFilter?.code=='shift'">
            <mat-calendar [selected]="selectedShiftDate" [maxDate]="today" [minDate]="minimumCalendarDate"
                (selectedChange)="onShiftDateSelect($event)" (click)="onShiftDateChange($event)"
                (keydown.enter)="onShiftDateChange($event)" (keydown.space)="onShiftDateChange($event)"></mat-calendar>
            <div class="radio-wrapper" *ngIf="showShift">
                <mat-radio-group [(ngModel)]="this.selectedShift" (change)="onShiftChange()" layout="row">
                    <mat-radio-button class="shift-radio-button" *ngFor="let shift of shiftFilters"
                        [value]="shift.code">
                        {{shift?.label}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        <div class="hour-filter" *ngIf="selectedTimeFilter?.code=='hour'">
            <mat-calendar [selected]="selectedHourDate" [maxDate]="today" [minDate]="minimumCalendarDate"
                (selectedChange)="onHourDateSelect($event)" *ngIf="!showHourFilter"></mat-calendar>
            <div class="hour-picker" *ngIf="showHourFilter">
                <div class="selectedDate">
                    <span matPrefix class="selectedDateSpan" (click)="editHourSelectedDate()"
                        (keydown.enter)="editHourSelectedDate()"
                        (keydown.space)="editHourSelectedDate()">{{this.selectedHourDate |
                        date : "dd MMMM yyyy"}}</span>
                    <mat-icon matSuffix class="selectedDateIcon" (click)="editHourSelectedDate()"
                        (keydown.enter)="editHourSelectedDate()" (keydown.space)="editHourSelectedDate()">calendar_today
                    </mat-icon>
                </div>
                <div class="hour" [ngClass]="{'selected':selectedHr?.hour == item?.hour}" matRipple
                    (click)="onHourChange(item)" (keydown.enter)="onHourChange(item)"
                    (keydown.space)="onHourChange(item)" *ngFor="let item of hourList">
                    {{item?.label}}
                </div>
            </div>
        </div>
    </div>
    <div class="arrow-up"></div>
</div>